import axios from 'axios';

const getInitialState = function () {
    return {
        brands: [],
        currentBrand: null,
        loaded: false,
    };
};

export default {
    namespaced: true,

    state: getInitialState(),

    getters: {
        brands: state => state.brands,
        currentBrand: state => state.currentBrand,
        isLoaded: state => state.loaded,
    },

    mutations: {
        setBrands(state, brands) {
            state.brands = brands;
            state.loaded = true;
        },
        setCurrentBrand(state, brand) {
            state.currentBrand = brand;
        },
        RESET_STATE(state) {
            Object.assign(state, getInitialState());
        },
    },

    actions: {
        async fetchBrands({ commit }) {
            try {
                const response = await axios.get('/brands');
                commit('setBrands', response.data);
                return response.data;
            } catch (error) {
                console.error('Error fetching brands:', error);
                throw error;
            }
        },

        determineBrand({ commit, state }, hostname) {
            const host = hostname.toLowerCase().replace(/:\d+$/, '');
            const brand = state.brands.find(b => {
                if (!b.domain) return false;
                const brandDomain = b.domain.toLowerCase().replace(/:\d+$/, '');
                // Exact match or subdomain match (e.g. dev.example.org matches example.org)
                return host === brandDomain || host.endsWith('.' + brandDomain);
            });

            const currentBrand = brand || null;
            commit('setCurrentBrand', currentBrand);

            // Also set on root store for backwards compatibility
            commit('setCurrentBrand', currentBrand, { root: true });

            return currentBrand;
        },
    },
};
